import React from 'react';
import { Fragment } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import brasao from '../../assets/images/brasao.png';
import atricon from '../../assets/images/atricon.png';
import '../../styles/footer.scss';

function Footer() {
    return (
        <Fragment>
            <footer className='rodape'>
                <Container>
                    <Row xs={1}>
                        <Col>
                            <img src={brasao} className="brasao-ft" alt="Prefeitura de Macuco" />
                        </Col>
                        <Col>
                            <p className="pref-ft">Prefeitura de <span className='upper'>Macuco</span></p>
                        </Col>
                    </Row>
                    <Row xs={1}>
                        <Col>
                            <p className="text-ft">Rua Doutor Mário Freire Martins, 100 - Centro - Macuco - RJ - CEP 28545-000
                                Telefone (22) 2554-9100</p>
                            <p className="text-ft">Horário de Atendimento: Segunda à Sexta-feira, das 9h às 17h</p>
                        </Col>
                        <Col>
                            <p className="text-ft">Serviço de Informação ao Cidadão - SIC presencial e ouvidoria presencial</p>
                            <p className="text-ft">Horário de Atendimento: Segunda à Sexta-feira, das 13h às 16h30min</p>
                            <p className="text-ft">Responsável: Gerlândia Alves Poubel</p>
                            <p className="text-ft">Local: Sede da Prefeitura - Rua Doutor Mário Freire Martins, 100 - Centro - Macuco - RJ - CEP 28545-000
                                E-mail: ouvidoria@prefeituramacuco.rj.gov.br</p>

                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p className="dev-by">Desenvolvido por: Departamento de Tecnologia da Informação</p>
                        </Col>
                    </Row>
                    <div className='atricon'>
                        <a href="https://prefeituramacuco.rj.gov.br/transparencia/atricon" target='_blank'>
                            <img src={atricon} className='atricon-img' alt="Lista de itens da Avaliação da ATRICON" />
                        </a>
                    </div>
                </Container>
            </footer>
        </Fragment>
    )
}

export default Footer;